import { useState, useEffect, useRef } from 'react';
import './App.css';
import logo from './assets/logo2.png';
import scrollGif from './assets/scroll-open.gif';
import parchmentImg from './assets/parchment-login.png';
import card1 from './assets/menu-team.png';
import card2 from './assets/menu-portfolio.png';
import card3 from './assets/menu-partners.png';
import card4 from './assets/card4.png'; 
import backArrow from './assets/fantasy-arrow.png';

import MemberCard from './components/MemberCard';
import { teamMembers } from './components/teamData.js';

import { portfolioItems } from './components/PortfolioData.js';
import PortfolioCard from './components/Portfolio.jsx';

import PartnerCard from './components/PartnerCard.jsx';
import { partnerItems } from './components/PartnerData.js';

const GIF_DURATION = 2000; // ms — adjust to match your scroll-open.gif

function App() {
  const [showLogin, setShowLogin] = useState(false);
  const [isPlayingScroll, setIsPlayingScroll] = useState(false);

  // which "page" is currently shown on the parchment
  const [currentView, setCurrentView] = useState('menu'); // 'menu' | 'team' | 'portfolio' | 'partners'
  // which view we’re transitioning to while the scroll is animating
  const [pendingView, setPendingView] = useState(null);
  // used to force the GIF to restart each time
  const [scrollKey, setScrollKey] = useState(0);

  // We want: close when clicking OUTSIDE scroll-content (even if inside scroll-shell/parchment)
  const scrollContentRef = useRef(null);
  // But don't close when clicking the back arrow (it sits outside scroll-content)
  const backArrowRef = useRef(null);

  const startScrollTo = (view) => {
    setPendingView(view);
    setIsPlayingScroll(true);
    setScrollKey((k) => k + 1); // force GIF remount => restarts animation
  };

  const openMenu = () => {
    setShowLogin(true);
    startScrollTo('menu'); // animate into menu
  };

  const closeMenu = () => {
    setShowLogin(false);
    setIsPlayingScroll(false);
    setPendingView(null);
    setCurrentView('menu'); // reset for next time
  };

  // When the scroll GIF is playing, wait GIF_DURATION then switch to the target view
  useEffect(() => {
    if (!isPlayingScroll || !pendingView) return;

    const timeoutId = setTimeout(() => {
      setIsPlayingScroll(false);
      setCurrentView(pendingView);
      setPendingView(null);
    }, GIF_DURATION);

    return () => clearTimeout(timeoutId);
  }, [isPlayingScroll, pendingView]);

  // Close when clicking outside scroll-content (NOT just outside scroll-shell)
  useEffect(() => {
    if (!showLogin) return;

    const handlePointerDown = (e) => {
      const contentEl = scrollContentRef.current;
      const backEl = backArrowRef.current;

      // During GIF, scroll-content isn't mounted yet.
      // If you *don't* want outside-click to close during animation, replace closeMenu() with return;
      if (!contentEl) {
        closeMenu();
        return;
      }

      const clickedInsideContent = contentEl.contains(e.target);
      const clickedBackArrow = backEl ? backEl.contains(e.target) : false;

      if (!clickedInsideContent && !clickedBackArrow) {
        closeMenu();
      }
    };

    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, [showLogin]);

  const renderScrollContent = () => {

    if (currentView === 'lore') {
  return (
    <div className="scroll-inner">
     <h2>Lore</h2>
<p>
  Adventure Creative Capital is a guild born from the powers of nine alongside elevated forces in a
  quest to bridge worlds beyond worlds.
</p>

<p>
  Ranging from the arts to magic internet money, the guild actively explores newer pastures and the
  world’s unknown.
</p>

<p>
  We love cool shit.
</p>

<p>
  ***
</p>

 <h2>Contact Us</h2>
<a href="mailto:Adventurecreativecapital@gmail.com">Adventurecreativecapital@gmail.com</a>

      {/* replace with your actual lore content */}
      {/* <div className="lore-body">
        <h3>The House</h3>
        <p>
          Born from craft, capital, and code, we back stories that become
          worlds—and worlds that become culture.
        </p>

        <h3>The Creed</h3>
        <ul>
          <li>Beauty is a moat.</li>
          <li>Discipline is the spell.</li>
          <li>Distribution is the dragon.</li>
        </ul>
      </div> */}
    </div>
  );
}

    if (currentView === 'menu') {
      return (
        <div className="scroll-menu">
          <button
            type="button"
            className="scroll-card"
            onClick={() => startScrollTo('team')}
          >
            <img src={card1} alt="Team" />
          </button>

          <button

            type="button"
            className="scroll-card"
            onClick={() => startScrollTo('lore')}
          >
            <img src={card4} alt="Lore" />
          </button>


          {/* <button
            type="button"
            className="scroll-card"
            onClick={() => startScrollTo('portfolio')}
          >
            <img src={card2} alt="Portfolio" />
          </button> */}

          {/* <button
            type="button"
            className="scroll-card"
            onClick={() => startScrollTo('partners')}
          >
            <img src={card3} alt="Partners" />
          </button> */}
        </div>
      );
    }

    if (currentView === 'team') {
      return (
        <div className="team-roster">
          <h1>Team</h1>
          <p>
            Meet the adventurers, strategists and storytellers behind Adventure
            Creative Capital.
          </p>

          {teamMembers.map((member) => (
            <MemberCard key={member.id} member={member} />
          ))}
        </div>
      );
    }

    if (currentView === 'portfolio') {
      const items = portfolioItems || [];

      return (
        <div className="scroll-inner">
          <h2>Portfolio</h2>
          <p>
            Legendary quests, famed campaigns and worlds we’ve helped bring to
            life.
          </p>

          <div className="portfolio-grid">
            {items.map((item) => (
              <PortfolioCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      );
    }

    if (currentView === 'partners') {
      const items = partnerItems || [];

      return (
        <div className="scroll-inner">
          <h2>Partners</h2>
          <p>Guilds, allies and fellow houses we proudly stand beside.</p>

          <div className="portfolio-grid">
            {items.map((partner) => (
              <PartnerCard key={partner.id} partner={partner} />
            ))}
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="App">
      <div className="splash">
        <div className="splash-content">
          <img src={logo} className="logo" alt="Adventure Creative Capital" />
        </div>

        <button className="btn-fantasy skip-btn" onClick={openMenu}>
          Menu
        </button>

        {showLogin && (
          <div className="scroll-overlay">
            <div className="scroll-shell" onClick={(e) => e.stopPropagation()}>
              {/* Back arrow – only show on subpages, not during animation */}
              {!isPlayingScroll && currentView !== 'menu' && (
                <button
                  ref={backArrowRef}
                  type="button"
                  className="back-arrow"
                  onClick={(e) => {
                    e.stopPropagation();
                    startScrollTo('menu');
                  }}
                >
                  <img
                    src={backArrow}
                    alt="Back to menu"
                    className="back-arrow-img"
                  />
                </button>
              )}

              {isPlayingScroll ? (
                <img
                  key={scrollKey} // forces GIF to restart each time
                  src={scrollGif}
                  className="scroll-gif"
                  alt="Scroll opening"
                />
              ) : (
                <div className="scroll-panel" key={currentView}>
                  <img src={parchmentImg} alt="" className="scroll-bg" />

                  {/* The ref goes here: close when clicking outside THIS area */}
                  <div className="scroll-content" ref={scrollContentRef}>
                    {renderScrollContent()}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
